import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../error_boundary_v1';
import SourceRequestsSearch from './search/source_requests_search';

function TopLevelSearch({
                          query,
                          featuresToken,
                          algoliaAppId,
                          algoliaSearchKey,
                          indexName,
                          reporterIndexName,
                          canPitchConnectionOpps,
                          showAds,
                          completeProfile,
                          profileLink,
                          view,
                          publication,
                          delayedFeed,
                          feedDelayMinutes,
                          canViewInsights,
                        }) {
  return (
    <ErrorBoundary>
      <SourceRequestsSearch
        query={query}
        featuresToken={featuresToken}
        algoliaAppId={algoliaAppId}
        algoliaSearchKey={algoliaSearchKey}
        indexName={indexName}
        reporterIndexName={reporterIndexName}
        canPitchConnectionOpps={canPitchConnectionOpps}
        showAds={showAds}
        completeProfile={completeProfile}
        profileLink={profileLink}
        view={view}
        publication={publication}
        delayedFeed={delayedFeed}
        feedDelayMinutes={feedDelayMinutes}
        canViewInsights={canViewInsights}
      />
    </ErrorBoundary>
  );
}

TopLevelSearch.propTypes = {
  query: PropTypes.string,
  featuresToken: PropTypes.string.isRequired,
  algoliaAppId: PropTypes.string.isRequired,
  algoliaSearchKey: PropTypes.string.isRequired,
  indexName: PropTypes.string.isRequired,
  reporterIndexName: PropTypes.string,
  canPitchConnectionOpps: PropTypes.bool,
  showAds: PropTypes.bool,
  completeProfile: PropTypes.bool,
  profileLink: PropTypes.string,
  view: PropTypes.string,
  publication: PropTypes.string,
  delayedFeed: PropTypes.bool,
  feedDelayMinutes: PropTypes.number,
  canViewInsights: PropTypes.bool,
};

TopLevelSearch.defaultProps = {
  query: '',
  canPitchConnectionOpps: true,
  showAds: false,
  completeProfile: false,
  profileLink: '',
  view: '',
  publication: '',
  reporterIndexName: '',
  delayedFeed: false,
  feedDelayMinutes: 90,
  canViewInsights: false,
};

export default TopLevelSearch;
